import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const accentSaveToCloudButton = isFeature('accent-save-to-cloud-button');
